import medContext from "./medContext";

import React, { useState } from "react";

function MedState(props) {
  const [med, setMed] = useState([]);
  return (
    <medContext.Provider value={{ med, setMed }}>
      {props.children}
    </medContext.Provider>
  );
}

export default MedState;
